import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/knowledge_area', component: List, name: 'knowledge_area.index'},
  {path: '/knowledge_area/store', component: Form, name: 'knowledge_area.store'},
  {path: '/knowledge_area/:id', component: Form, name: 'knowledge_area.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/knowledge_area/routes.js